module.exports = __webpack_public_path__ + "files/bulk_properties_example.csv";